export default {
  computed: {
    isCourseUrl () {
      if (this.$isApp) return false
      return !window.location.href.startsWith(process.env.VUE_APP_EAD_URL)
    }
  }
}